import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Route,Router, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from '../../../services/login/login.service';

@Injectable({
  providedIn: 'root'
})
export class ClientesKabiCoinsGuard implements CanActivate, CanLoad {
  constructor(private authService: LoginService, private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (this.authService.getClientesKabiCoins()) {
        return true;
      }
      this.router.navigate(['/']);
      return false;
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    // return true;
    if (this.authService.getClientesKabiCoins()) {
      return true;
    }
    this.router.navigate(['/']);
    return false;
  }
}
